import React from 'react';
import PropTypes from 'prop-types';

const CategoryType = ({ data }) => {
  let displayText = "";
  switch (data){
    case 1:
      displayText = "Höfuðstóll";
      break;
    case 2:
      displayText = "Kostnaður";
      break;
    case 3:
      displayText = "Innborgun";
      break;
    case 4:
      displayText = "Skil";
      break;
    case 5:
      displayText = "Afsláttur";
      break;
    default:
      displayText = "Ekki þekkt tegund";
      break;
  }
  return (
    <span>{displayText}</span>
  );
};

CategoryType.propTypes = {
  data: PropTypes.number,
};

export default CategoryType;
